<template>
    <div>
        <section  class="mb-5 mt-2">
            <b-card v-for="(ride, index) in rides" :key="index" class="mb-3 ride-card shadow-sm" :class="{ 'striped': index % 2 !== 0 }" >
                <div class="card-header-custom">
                    <b-row align-v="center" no-gutters>
                        <b-col cols="12" md="5" class="mb-2 mb-md-0">
                            <div class="d-flex align-items-center">
                                <md-icon icon="store" class="mr-2 text-muted header-icon"></md-icon>
                                <span class="sales-channel">{{ ride.salesChannel.name }}</span>
                            </div>
                        </b-col>
                        <b-col cols="12" md="7">
                            <div class="text-md-right d-flex flex-wrap align-items-center justify-content-md-end">
                                <a href="#" class="service-number mr-2" @click="openReservation(ride)">
                                    <md-icon icon="confirmation_number" class="mr-1 header-icon"></md-icon>
                                    {{ ride.serviceNumber }}
                                </a>
                                <b-badge :variant="getVariantBystatus(ride.status)" class="status-badge">
                                    {{ ride.status }}
                                </b-badge>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <b-card-body class="ride-details p-0 pt-1">
                    <!-- Rate Plan Section -->
                    <div v-if="ride.ratePlan" class="rate-plan-section mb-3">
                        <div class="d-flex align-items-start">
                            <md-icon icon="loyalty" class="mr-2 text-muted"></md-icon>
                            <div class="flex-grow-1">
                                <div class="rate-plan-name">
                                    <a 
                                     @click="showTraceSupplierCosts(ride.id)" href="#">
                                        {{ ride.ratePlan.name }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Trip Details -->
                    <b-row class="trip-info mb-2">
                        <b-col cols="12">
                            <div class="d-flex align-items-center mb-2">
                                <md-icon icon="event" class="mr-2 text-muted"></md-icon>
                                <span class="info-label">Pickup Date:</span>
                                <span class="info-value ml-2">{{ ride.pickupDatetime }}</span>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row class="location-info mb-2">
                        <b-col cols="12">
                            <div class="d-flex align-items-start mb-2">
                                <md-icon icon="place" class="mr-2 text-muted"></md-icon>
                                <div>
                                    <div class="info-label">Pickup</div>
                                    <div class="location-name">{{ ride.pickup.name }}</div>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="d-flex align-items-start">
                                <md-icon icon="flag" class="mr-2 text-muted"></md-icon>
                                <div>
                                    <div class="info-label">Dropoff</div>
                                    <div class="location-name">{{ ride.dropoff.name }}</div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>

                    <!-- Supplier Info -->
                    <b-row class="supplier-info mt-3">
                        <b-col cols="12" md="6">
                            <div class="d-flex align-items-center">
                                <md-icon icon="local_shipping" class="mr-2 text-muted"></md-icon>
                                <div>
                                    <span class="info-label">Proveedor:</span>
                                    <div>
                                        <small v-if="ride.currentSupplier.id != ride.supplier.id" class="text-muted strikethrough mr-1">
                                            {{ ride.currentSupplier.name }}
                                        </small>
                                        <span class="supplier-name">{{ ride.supplier.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12" md="6" class="mt-2 mt-md-0">
                            <div class="d-flex align-items-center">
                                <md-icon icon="directions_car" class="mr-2 text-muted"></md-icon>
                                <div>
                                    <span class="info-label">Service Type:</span>
                                    <div class="service-type">{{ ride.supplierServiceType.name }}</div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card-body>
                <template #footer>
                    <b-row align-v="center" class="footer-row">
                        <b-col cols="12" md="6">
                            <div class="action-buttons">
                                <b-button
                                    size="sm"
                                    v-b-tooltip.hover
                                    title="Remover de la asignación"
                                    variant="outline-danger"
                                    @click="removeItem(index)"
                                    class="action-btn"
                                >
                                    <md-icon icon="delete"></md-icon>
                                </b-button>
                                <b-button
                                    size="sm"
                                    v-b-tooltip.hover
                                    title="Historial de asignaciones"
                                    variant="outline-success"
                                    @click="showHistorySupplier(ride.id)"
                                    class="action-btn"
                                >
                                    <md-icon icon="timeline"></md-icon>
                                </b-button>
                                <b-button
                                    size="sm"
                                    v-b-tooltip.hover
                                    title="Trace del cálculo de costos"
                                    variant="outline-info"
                                    @click="showTraceSupplierCosts(ride.id)"
                                    v-if="massiveAssignmenItems.length > 0"
                                    class="action-btn"
                                >
                                    <md-icon icon="info_outline"></md-icon>
                                </b-button>
                            </div>
                        </b-col>
                        <b-col cols="12" md="6" class="mt-3 mt-md-0">
                            <div class="profit-display">
                                <div class="profit-badge" :class="getProfitClass(ride.profitPercent)">
                                    <span class="profit-amount">${{ numberFormat(ride.profit,2) }}</span>
                                    <span class="profit-percent">{{ numberFormat(ride.profitPercent,1) }}%</span>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </template>
            </b-card>
        </section>
        <div class="fixed-bottom mt-3"  >
           
        </div>
        <div class="fixed-bottom bg-secondary text-center py-2">
            <b-button  variant="outline-warning" @click="cancel"  v-if="massiveAssignmenItems.length>0" class="mr-3">Cancelar <b></b></b-button>
            <b-button  variant="success" @click="assignRides" v-if="rides.length>0" >Asignar <b>({{  rides.length }})</b></b-button>
        </div>
        <b-overlay :show="loading" no-wrap></b-overlay>
        <b-modal
			hide-footer
			ref="supplier-history"
			size="xl"
			:title="`Historial`"
		>
			<HistorySupplierAssignation :transportServiceId="tsSelected" />
		</b-modal>

        <TrackingSupplierCosts 
            v-if="massiveAssignmenItems.length > 0"
            ref="tracking-supplier-costs"
            :supplierId="massiveAssignmenItems[0].supplierId"
            :supplierServiceTypeId="massiveAssignmenItems[0].supplierServiceTypeId"
            />
        
    </div>
</template>

<script>

import HistorySupplierAssignation from "@/components/sections/reservations/HistorySupplierAssignation";
import TrackingSupplierCosts from "../../TrackingSupplierCosts.vue";
export default {
    props: {
        massiveAssignmenItems:{
            type: Array,
            required: false
        },
    },
    components: { HistorySupplierAssignation, TrackingSupplierCosts },
    data() {
        return {
            loading: false,
            rides:[],
            tsSelected:-1
        }
    },
    methods: {
        fetchAssignmentReview(){
            try {
                return this.$root.api
                .post(`/assignment/tool/massive/preview`,{settings:this.massiveAssignmenItems})
            } catch(error) {
                console.error('Error fetching rides:', error);
                return []; // Return an empty array in case of error
            }
        },
        async restore(){
            this.loading=true;
            let response = await this.fetchAssignmentReview();
            this.rides = response.data.rides;
            this.loading = false;
        },
        load(){
            this.restore();
        },
        async assignRides(ev) {
            ev.preventDefault();
            let ridesToAssign = this.rides.map((ride)=>{
                return {
                    id: ride.id,
                    s_id: ride.supplier.id,
                    sst_id:ride.supplierServiceType.id
                }
            })
            this.loading = true;
            this.$root.api
            .put(`/assignment/tool/massive`, {
                rides: ridesToAssign
            })
            .then(() => {
                this.loading = false;
                this.$root.showAlert("Actualizacion exitosa");
                this.done();
            })
            .catch(err => {
                this.$root.handleRequestError(err);
                this.loading = false;
            });
            
        },
        getVariantBystatus(status){
            try{
                let variant = this.$root.auxVars.transportServiceStatusOpts.find((el)=>{
                    return el.value==status
                });
                if(variant) return variant.class;
            }catch(err){console.log(err)}
            return "info";
        },  
        removeItem(index){
            this.rides.splice(index, 1);
        },
        numberFormat(number, decimals = 0, decPoint = '.', thousandsSep = ',') {
            // Ensure the number is a valid number
            if (isNaN(number)) return '0';

            // Check if the number is a whole number
            const hasDecimals = decimals > 0 && (number % 1 !== 0);

            const fixedNumber = number.toFixed(hasDecimals ? decimals : 0); // Fix decimal points only if needed
            const parts = fixedNumber.split('.'); // Split into integer and decimal parts

            // Format the integer part with the thousands separator
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);

            // Return the integer part or the joined integer and decimal part
            return hasDecimals ? parts.join(decPoint) : parts[0];
        },
        openReservation(ride){
            this.$emit("openReservation",{reservationId:ride.resId})
        },
        showHistorySupplier(tsId) {
            this.tsSelected=tsId;
            this.$refs["supplier-history"].show();
        },
        showTraceSupplierCosts(tsId) {
            // show modal trace suppliers cost
            this.$refs['tracking-supplier-costs'].showTrackingCosts(tsId)           
        },
        cancel(){
            this.$emit("close",{})
        },
        done(){
            let ridesAssigned = this.rides.map((ride)=>{
                return {
                    id: ride.id
                }
            })
            this.$emit("done",{rides:ridesAssigned})
        },
        formatDate(dateString) {
            if (!dateString) return '';
            try {
                const date = new Date(dateString);
                const options = { year: 'numeric', month: 'short', day: '2-digit' };
                return date.toLocaleDateString('es-ES', options);
            } catch (error) {
                return dateString;
            }
        },
        formatTime(timeString) {
            if (!timeString) return '';
            try {
                // Si el tiempo viene en formato HH:MM:SS, extraer solo HH:MM
                const timeParts = timeString.split(':');
                if (timeParts.length >= 2) {
                    return `${timeParts[0]}:${timeParts[1]}`;
                }
                return timeString;
            } catch (error) {
                return timeString;
            }
        },
        getProfitClass(profitPercent) {
            if (profitPercent <= 0) return 'profit-negative';
            if (profitPercent >= 10) return 'profit-high';
            return 'profit-low';
        }
    }
}
</script>
<style scoped>
/* Card Styling */
.ride-card {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    transition: all 0.3s ease;
    overflow: hidden;
}

.ride-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
    transform: translateY(-2px);
}

.ride-card.striped {
    background-color: #f8f9fa;
}

/* Header Custom */
.card-header-custom {
    padding: 0.75rem 1rem;
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
}

.header-icon {
    font-size: 18px;
}

.sales-channel {
    font-weight: 600;
    font-size: 12px;
    color: #495057;
    line-height: 1.3;
    word-break: break-word;
}

.service-number {
    color: #0d6efd;
    font-weight: 600;
    font-size: 12px;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    transition: all 0.2s;
    white-space: nowrap;
}

.service-number:hover {
    color: #0a58ca;
    text-decoration: underline;
}

.status-badge {
    font-size: 9px;
    padding: 0.25rem 0.5rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

/* Card Body */
.ride-details {
    padding: 1.25rem;
}

/* Rate Plan Section */
.rate-plan-section {
    background-color: #f8f9fa;
    border-left: 4px solid #6c757d;
    padding: 0.75rem 1rem;
    border-radius: 6px;
    border: 1px solid #e9ecef;
}

.rate-plan-name {
    font-weight: 600;
    color: #212529;
    font-size: 12px;
    line-height: 1.4;
}

.traveler-window {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
}

.window-icon {
    font-size: 16px;
    color: #6c757d;
    margin-right: 0.5rem;
}

.window-text {
    font-size: 0.85rem;
    color: #495057;
    font-weight: 500;
}

.service-time {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
}

.time-icon {
    font-size: 16px;
    color: #6c757d;
    margin-right: 0.5rem;
}

.time-text {
    font-size: 0.85rem;
    color: #495057;
    font-weight: 500;
}

/* Trip Info */
.info-label {
    font-weight: 600;
    color: #6c757d;
    font-size: 0.85rem;
}

.info-value {
    color: #212529;
    font-size: 0.9rem;
}

.location-name {
    color: #495057;
    font-size: 0.9rem;
    font-weight: 500;
    margin-top: 0.25rem;
}

/* Supplier Info */
.supplier-name {
    font-weight: 600;
    color: #212529;
    font-size: 0.9rem;
}

.service-type {
    font-weight: 500;
    color: #495057;
    font-size: 0.9rem;
    margin-top: 0.25rem;
}

.strikethrough {
    text-decoration: line-through;
}

/* Footer */
.ride-card .card-footer {
    padding: 0.75rem 1.25rem;
    background-color: #f9fafb;
    border-top: 1px solid #e5e7eb;
}

.footer-row {
    align-items: center;
}

.action-buttons {
    display: flex;
    gap: 0.5rem;
}

.action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    transition: all 0.2s;
}

.action-btn:hover {
    transform: translateY(-1px);
}

/* Profit Display */
.profit-display {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.profit-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.4rem 0.75rem;
    border-radius: 5px;
    font-weight: 600;
    white-space: nowrap;
    min-width: fit-content;
}

.profit-amount {
    font-size: 13px;
    line-height: 1;
}

.profit-percent {
    font-size: 12px;
    line-height: 1;
    opacity: 0.95;
}

.profit-negative {
    background-color: #fee2e2;
    color: #991b1b;
    border: 1px solid #fca5a5;
}

.profit-low {
    background-color: #fef3c7;
    color: #92400e;
    border: 1px solid #fcd34d;
}

.profit-high {
    background-color: #d1fae5;
    color: #065f46;
    border: 1px solid #6ee7b7;
}

/* Bottom Action Bar */
.fixed-bottom {
    z-index: 1000;
}

/* Responsive */
@media (max-width: 768px) {
    .card-header-custom {
        padding: 0.6rem 0.8rem;
    }

    .header-icon {
        font-size: 16px;
    }

    .sales-channel {
        font-size: 11px;
    }

    .service-number {
        font-size: 11px;
    }

    .ride-details {
        padding: 0.8rem;
    }

    .rate-plan-name {
        font-size: 11px;
    }

    .window-text {
        font-size: 10px;
    }

    .time-text {
        font-size: 10px;
    }

    .action-buttons {
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 0.3rem;
    }

    .action-btn {
        padding: 0.4rem 0.6rem;
    }

    .profit-display {
        justify-content: center;
        width: 100%;
    }

    .profit-badge {
        width: auto;
        max-width: 100%;
        justify-content: center;
        padding: 0.45rem 0.7rem;
        gap: 0.4rem;
    }

    .profit-amount {
        font-size: 12px;
    }

    .profit-percent {
        font-size: 11px;
    }
}

/* Material Icons alignment */
md-icon {
    vertical-align: middle;
}
</style>